module.exports = __webpack_public_path__ + "static/media/shelter_boatyard_marker.f46b94a7.svg";